import React, {Component} from 'react'
import KeywordManager from "./KeywordManager"

class KeywordsPage extends Component {
    render() {
        return (
            <div className="KeywordsPage">
                <KeywordManager/>
            </div>
        )
    }
}

export default KeywordsPage



// WEBPACK FOOTER //
// ./src/app/pages/dashboard/keywords/components/KeywordsPage.js